import { ProductCategories as Page } from './ProductCategories.main';
import { ProductCategoriesHeader as Header } from './ProductCategoriesHeader';

export { Filters } from './Filters';
export { CategoriesTable } from './CategoriesTable';

export const ProductCategories = { Header, Page };
